export var isObjectError = function (err, errorName) {
    return err &&
        err.response &&
        err.response.data &&
        err.response.data.error &&
        err.response.data.error.name &&
        err.response.data.error.name === errorName;
};
